export default "__VITE_ASSET__B_OSdqOG__"